<div class="container-fluid highlight-cursor">
  <form [formGroup]="detailForm" (ngSubmit)="onSave()">

    <div class="row">

      <div *showIfDebugMode class="col-3">
        <mat-form-field class="w-100">
          <mat-label>Id</mat-label>
          <input id="id" matInput formControlName="id">
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'PROJECT.TYPE' | translate }}</mat-label>
          <mat-select formControlName="projectType" (selectionChange)="onProjectTypeChange($event.value)">
            @for (t of projectTypes; track t.id) {
              <mat-option [value]="t">{{ t.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'PROJECT.NUMBER' | translate }}</mat-label>
          <input id="number" matInput formControlName="number">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-12 col-md-6 col-lg-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'PROJECT.STARTDATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
          <mat-hint>{{ 'DATE.FORMAT' | translate }}</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'PROJECT.TERMINATIONDATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="terminationDatePicker" formControlName="terminationDate">
          <mat-hint>{{ 'DATE.FORMAT' | translate }}</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="terminationDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #terminationDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'STATUS' | translate }}</mat-label>
          <input matInput [value]="localizedStatus" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">
      <div class="col-6 my-2" *hasPermission="Permission.INSPECTION_TYPE_EDIT">
        <button type="submit" mat-raised-button color="primary" [disabled]="detailForm.pristine || !detailForm.valid" class="me-2">
          {{ 'SAVE.SAVE' | translate }}
        </button>
        <button type="button" mat-raised-button (click)="onCancel()" [disabled]="detailForm.pristine" class="me-2">
          {{ 'CANCEL' | translate }}
        </button>
        <button type="button" mat-raised-button (click)="switchStatus(statusAction)" [disabled]="!detailForm.get('id')?.value" class="me-2">
          {{ (statusAction) | translate }}
        </button>
      </div>
    </div>

  </form>

  <p-confirmDialog></p-confirmDialog>
</div>


